import { createFileRoute } from '@tanstack/react-router';

import { bankAccountRequestDetailScreen, bankAccountRequestDetailSearch, loadBankAccountRequestDetailScreen, loadBankAccountRequestMessages } from '@/modules/bank-account-request/route';
import { lazyScreen } from '@/shared/screen';

// Mesmo caminho do legado (`/contas-digitais/solicitacoes/:bankAccountId`, router.tsx:606-641); `nova` cria. A aba vai em `?tab=` (U42).
export const Route = createFileRoute('/_app/contas-digitais/solicitacoes/$bankAccountId/')({
  validateSearch: bankAccountRequestDetailSearch,
  staticData: { screen: bankAccountRequestDetailScreen },
  loader: () => loadBankAccountRequestMessages(),
  component: lazyScreen(loadBankAccountRequestDetailScreen, 'BankAccountRequestDetailScreen'),
});
